export default {
    config: {
        shareUrl: {
            default: {
                baseUrl: 'https://vk.com/share.php',
                params: {
                    url: 'url',
                    title: 'title',
                    description: 'description',
                    image: 'image'
                }
            }
        }
    },

    popupDimensions: [550, 420],

    i18n: {
        az: 'VKontakte',
        be: 'Ð’ÐšÐ¾Ð½Ñ‚Ð°ÐºÑ‚Ðµ',
        en: 'VKontakte',
        hy: 'VKontakte',
        ka: 'VKontakte',
        kk: 'Ð’ÐšÐ¾Ð½Ñ‚Ð°ÐºÑ‚Ðµ',
        ro: 'VKontakte',
        ru: 'Ð’ÐšÐ¾Ð½Ñ‚Ð°ÐºÑ‚Ðµ',
        tr: 'VKontakte',
        tt: 'Ð’ÐšÐ¾Ð½Ñ‚Ð°ÐºÑ‚Ðµ',
        uk: 'Ð’ÐšÐ¾Ð½Ñ‚Ð°ÐºÑ‚Ñ–',
        uz: 'VKontakte'
    },

    color: '#07f'
};
